(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/syndicate/core/assets/javascripts/models/invitee.js') >= 0) return;  svs.modules.push('/components/syndicate/core/assets/javascripts/models/invitee.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.syndicate.core.models.Invitee = Backbone.Model.extend({
    initialize: function() {
      this.updateActions();
    },

    updateActions: function() {
      var actions = [];

      actions.push({
        actionClass: 'js-remove-invitee',
        text: 'Ta bort'
      });

      actions.push({
        actionClass: 'js-remind-invitee',
        text: 'Påminn'
      });

      this.set('actions', actions);
    },

    remove: function() {
      var self = this,
        email = this.get('email');

      var dialogRemoveStart = new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        icon: 'e-post',
        title: 'Bekräfta',
        message: [
          {
            type: svs.ui.dialog.message.TEXT,
            text: 'Vill du ta bort inbjudan skickad till <strong>' + this.get('email') + '</strong>?'
          }
        ],
        actions: [
          {
            type: svs.ui.dialog.button.SECONDARY,
            title: 'Avbryt'
          },
          {
            type: svs.ui.dialog.button.PRIMARY,
            title: 'Ta bort',
            showLoader: true,
            callback: function() {
              self.get('syndicateModel').removeInvitee(self, { silent: false }, function(err) {
                var dialog;
                if (err) {
                  svs.syndicate.syndicate_detail.logger.error('Error when removing invitee: ' + err);
                  dialog = new svs.ui.dialog.Confirm({
                    branding: svs.ui.dialog.branding.TUR,
                    type: svs.ui.dialog.type.ERROR,
                    title: 'Tekniskt fel',
                    message: [
                      {
                        type: svs.ui.dialog.message.TEXT,
                        text: 'Ett fel uppstod vid bortagandet av inbjudan.'
                      }
                    ],
                    actions: [
                      {
                        title: 'Okej',
                        callback: function() {
                          dialog.close(function() {
                            window.location.reload(true);
                          });
                        }
                      }
                    ]
                  });
                } else {
                  dialog = new svs.ui.dialog.Confirm({
                    branding: svs.ui.dialog.branding.TUR,
                    icon: 'checkmark',
                    title: email + ' har tagits bort.',
                    actions: [{ title: 'Okej' }]
                  });
                }
                svs.ui.dialog.api.add(dialog);
                dialogRemoveStart.close();
              });
            }
          }
        ]
      });
      svs.ui.dialog.api.add(dialogRemoveStart);
    },

    remind: function() {
      var self = this,
        options = {
          path: '/social/1/syndicates/invitationreminders',
          data: {
            invitationId: this.get('invitationId')
          }
        };

      svs.core.jupiter.post(options, function() {
        svs.ui.dialog.api.add(
          new svs.ui.dialog.Confirm({
            branding: svs.ui.dialog.branding.TUR,
            icon: 'checkmark',
            title: 'En påminnelse har skickats till ' + self.get('email'),
            actions: [{ title: 'Okej' }]
          })
        );
      }, function(xhr, textStatus) {
        svs.syndicate.syndicate_detail.logger.error('Error when reminding invitee: ' + textStatus);
        svs.ui.dialog.api.add(
          new svs.ui.dialog.Confirm({
            branding: svs.ui.dialog.branding.TUR,
            type: svs.ui.dialog.type.ERROR,
            title: 'Tekniskt fel',
            message: [
              {
                type: svs.ui.dialog.message.TEXT,
                text: 'Ett fel uppstod vid försök att påminna en inbjudan.'
              }
            ],
            actions: [{ title: 'Okej' }]
          })
        );
      });
    }
  });
})(Backbone, _, svs);


 })(window);